import { ReactNode, useMemo } from 'react'
import { matchPath, useLocation } from 'react-router-dom'

import { SubscribePlaceholder } from '@/shared/ui/placeholder/SubscribePlaceholder'
import { SidebarItem } from '@/utils/subscription/types'

export type ProtectedPageProps = {
  children?: ReactNode
  subscriptionSidebarItems: SidebarItem[]
}

const whiteListRoutes = [
  '/',
  '/configuration',
  '/connector',
  '/licenses',
  '/licenses/:licenseId',
  '/notifications',
  '/subscribe',
  '/prescription',
  '/shift-marketplace',
  '/planning/admin',
  '/admin/forms',
  '/admin/knowledge-base',
  '/admin/knowledge-base/:collectionId',
  '/admin/trusted-actors',
  '/forms/submit/:templateId/:patientId',
  '/forms/submit/:templateId/:patientId/:submissionId',
  '/forms/submissions/:submissionId',
  '/admin/forms/:templatesId',
  '/chat',
  '/admin/desmos-acts',
  '/ai-transparency',
]

export function SubscriptionChecker(props: ProtectedPageProps) {
  const { children, subscriptionSidebarItems } = props
  const location = useLocation()
  const pathname = location.pathname

  const isRouteAccessible = useMemo(() => {
    return subscriptionSidebarItems.some((item) => pathname.startsWith(item.link))
  }, [pathname, subscriptionSidebarItems])

  const isRouteWhiteListed = useMemo(() => whiteListRoutes.some((route) => !!matchPath(route, pathname)), [pathname, whiteListRoutes])

  if (!isRouteAccessible && !isRouteWhiteListed) return <SubscribePlaceholder />

  return <>{children}</>
}

export default SubscriptionChecker
